import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/useAuthStore';
import { ROUTES } from '@/constants/routes';
import styles from './PendingApproval.module.css';

export function PendingApproval() {
  const navigate = useNavigate();
  const getUser = useAuthStore((s) => s.getUser);
  const logOut = useAuthStore((s) => s.logOut);
  const isLogged = useAuthStore((s) => s.isLogged);
  const user = getUser();

  useEffect(() => {
    if (!isLogged) {
      navigate(ROUTES.login);
      return;
    }
    // If user is staff, they shouldn't be here
    if (user?.is_staff) {
      navigate(ROUTES.dashboard);
    }
  }, [isLogged, user, navigate]);

  const handleLogout = async () => {
    await logOut();
    navigate(ROUTES.login);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <Clock size={32} />
        </div>
        <h1 className={styles.title}>Account Pending Approval</h1>
        <p className={styles.message}>
          Your account has been created and your email is verified. An administrator needs to
          approve your account before you can access the dashboard.
        </p>
        <p className={styles.submessage}>
          You'll be able to log in once an admin approves your account.
        </p>
        <button className={styles.logoutButton} onClick={handleLogout}>
          <LogOut size={16} />
          Log Out
        </button>
      </div>
    </div>
  );
}
